export enum TrackChangesApprovalTexts {
    Accepted = 'Accepted Edits',
    Rejected = 'Rejected Edits',
}
